<div [hidden]="!$displayFilters()">
  <form [formGroup]="filtersFormGroup" class="filters">
    <header>
      <h4 class="filters_title">{{ 'COMMON.FILTERS' | translate }}</h4>
      <div class="actions">
        @if (!!$filtersCount()) {
          <button mat-button (click)="resetFilters()">{{ 'COMMON.RESET' | translate }}</button>
        }
        @if (showCloseIcon) {
          <button matMiniFab (click)="toggleFilters()" [matTooltip]="'COMMON.CLOSE' | translate">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </header>

    <!-- Type filter -->
    @if (selectMode) {
      <chips-filter
        formControlName="typeFilter"
        [items]="TYPE_ITEMS"
        [label]="'DEVICE.FILTERS.BY_TYPE' | translate"
        [placeholder]="'DEVICE.FILTERS.SELECT_TYPE_PLACEHOLDER' | translate" />
    } @else {
      <div class="checkbox-filter">
        <span class="checkbox-filter__label">{{ 'DEVICE.FILTERS.BY_TYPE' | translate }}</span>
        @for (item of TYPE_ITEMS; track item.value) {
          <mat-checkbox
            [checked]="isChecked('typeFilter', item.value)"
            (click)="$event.stopPropagation()"
            (change)="toggleCheckbox('typeFilter', item.value)">
            {{ item.label }}
          </mat-checkbox>
        }
      </div>
    }

    <!-- Status filter -->
    @if (selectMode) {
      @if (!$hideStatusFilter()) {
        <chips-filter
          formControlName="statusFilter"
          [items]="STATUS_ITEMS"
          [label]="'DEVICE.STATUS.BY_STATE' | translate"
          [placeholder]="'DEVICE.STATUS.SELECT' | translate" />
      }
    } @else {
      <div class="checkbox-filter">
        <span class="checkbox-filter__label">{{ 'DEVICE.STATUS.BY_STATE' | translate }}</span>
        @for (item of STATUS_ITEMS; track item.value) {
          <mat-checkbox
            [checked]="isChecked('statusFilter', item.value)"
            [disabled]="$hideStatusFilter()"
            (click)="$event.stopPropagation()"
            (change)="toggleCheckbox('statusFilter', item.value)">
            <mat-chip class="chip" [class]="$hideStatusFilter() ? 'inactive' : item.value">
              {{ item.label }}
            </mat-chip>
          </mat-checkbox>
        }
      </div>
    }

    <!-- Unit filter -->
    @if (selectMode) {
      <tree-select
        formControlName="unitsFilter"
        [label]="'DEVICE.FILTERS.BY_SERVICE' | translate"
        [placeholder]="'DEVICE.FILTERS.SELECT_UNIT_PLACEHOLDER' | translate"
        [searchPlaceholder]="'DEVICE.SEARCH_UNIT' | translate"
        entityType="service" />
    } @else {
      <div class="checkbox-filter">
        <span class="checkbox-filter__label">{{ 'DEVICE.FILTERS.BY_SERVICE' | translate }}</span>
        <tree
          [closable]="false"
          [selected]="selectedUnitUids"
          [fieldset]="false"
          element="service"
          [elementSelectedType]="'node'"
          [labelSearch]="'DEVICE.SEARCH_UNIT' | translate"
          [maxHeight]="200"
          (selectedCheckbox)="onSelectTreeUnits($event)" />
      </div>
    }
  </form>
</div>
